import { company } from "@/data/company";
import logoLight from "@/assets/lx-logo-light.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-ink text-white/70 py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-b border-cream/10 pb-12">
          <div>
            <img src={logoLight} alt="LX Bouw logo" className="h-16 w-auto" />
            <p className="font-body text-sm mt-6 max-w-xs leading-relaxed">
              Kwalitatieve nieuwbouwwoningen en kleinschalige woonprojecten in
              het Waasland.
            </p>
          </div>
          <div className="font-body text-sm space-y-2">
            <p>{company.street}, {company.city}</p>
            <a href={`tel:${company.phoneRaw}`} className="block link-underline w-fit">{company.phone}</a>
            <a href={`mailto:${company.email}`} className="block link-underline w-fit">{company.email}</a>
            <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="block link-underline w-fit pt-2 text-white/85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-4 focus-visible:ring-offset-ink">
              Privacybeleid
            </Link>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 mt-8 font-body text-xs text-cream/50">
          <p>© {new Date().getFullYear()} LX Bouw — Alle rechten voorbehouden.</p>
          <p>Woningbouw · Kleinschalige projecten</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
